var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIconFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comment_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 10.4026C0 15.5875 5.3846 19.8053 12.0005 19.8053C13.4634 19.8053 14.9021 19.5955 16.2764 19.1831L16.5684 19.0958L19.9333 22.2571V17.4459L20.1572 17.2826C22.5993 15.5034 24 12.9953 24 10.4026C24 5.2183 18.6154 1 12.0005 1C5.3846 1 0 5.2183 0 10.4026Z",
    fill: "#202021"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIconFilled);
export default __webpack_public_path__ + "static/media/comment_icon_filled.a37449a41edb79b3d2dc4f5e86a8a45a.svg";
export { ForwardRef as ReactComponent };